var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-3",attrs:{"align":"center"}},[_c('h4',{staticClass:"text_box2_1_1"},[_c('img',{staticStyle:{"width":"30px"},attrs:{"src":require("@/assets/images/NikhomLatKrabang/3.png"),"alt":""}}),_vm._v(" "+_vm._s(_vm.header))])])}
var staticRenderFns = []

export { render, staticRenderFns }